import { all, call, delay, put, take, takeLatest } from 'redux-saga/effects'

function* getCommonDataRequest() {
    try {
    } catch (err) {
        yield call(
        );
        // handle error message here
    }
}

function* rootSaga() {
    yield all([
        takeLatest("GET_COMMON_DATA_REQUEST", getCommonDataRequest),
    ])
}

export default rootSaga
